<template>
  <ModalComponent
    :model-value="showRef"
    :close="closeModalImg"
    :style-class="styleClass"
  >
    <img
      :src="urlAttachment"
      style="object-fit: contain; width: 100%; height: 100%"
      @click.stop
    />
  </ModalComponent>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";

const emit = defineEmits(["update:show"]);
const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  urlAttachment: {
    type: String,
    default: "",
  },
});
const showRef = ref(props.show);
const isModalImgShown = ref(false);
const styleClass = { background: "rgba(0, 0, 0, 0.5)", top: "0px" };

const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const closeModalImg = () => {
  isModalImgShown.value = false;
  handleCloseModal();
};

const initial = () => {
  isModalImgShown.value = true;
};

onMounted(() => initial());

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);
</script>

<style lang="scss" scope>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.5);
  // opacity: 0.5;
  z-index: 2;
  top: 0;
  left: 0;
}
</style>
